
// Fonctions géneriques pouvant être utilisées pour le composant common ListItemWithCheckbox.
export default {
  methods: {
    // Fonction génerique d'initalisation des checkbox, prenant : la valeur actuelle de l'objet, le catalogue des valeurs possibles et le tableau à lier.
    setupCheckbox(valeur, catalogue, checkboxes) {
      catalogue.forEach((property) => {
        const fd = { ...property }
        fd.value = false

        if (valeur?.id === fd.id) {
          fd.value = true
        }

        checkboxes.push(fd)
      })
    },
    // Fonction génerique de mise à jour des checkbox, prenant : l'evenement de l'emit, la réference de l'objet à mettre à jour, 
    // le nom du parametre de l'objet à mettre à jour, le catalogue des valeurs possibles et le tableau lié.
    updateCheckbox(payload, valeur, param, catalogue, checkboxes) {
      const dataId = parseInt(payload.field)

      valeur[param] = catalogue.filter((ar) => ar.id === dataId)[0];

      checkboxes.forEach((checkbox) => {      
        if (checkbox.id != dataId) {
          checkbox.value = false
        }
        else {
          checkbox.value = true
        }
      })
    },
  },
}